module.exports = __webpack_public_path__ + "img/sarah-weitnauer.2430f83d.jpg";